import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http'
import 'rxjs/add/operator/toPromise'
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

import { SeguridadService } from '../_services/seguridad.service'

import { AppSettings } from '../_models/settings.models'

@Injectable()

export class NormasService{



  constructor(private http: Http,
              private seguridad: SeguridadService
            ){

  }

  getListaNormas(){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ tokenid: userToken, action: "ListagetNormas", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getListaNormasMaestras(id_modulo: number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({id_modulo: id_modulo,  tokenid: userToken, action: "ListagetNormasMaestra", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getListaModulosAfectados(id_norma: number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_norma: id_norma, tokenid: userToken, action: "ListagetNormasMaestra", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getIdentNorma(id_norma: number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_norma: id_norma, tokenid: userToken, action: "NormagetIdentNorma", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getIdentNormaMaestra(id_norma: number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_norma: id_norma, tokenid: userToken, action: "MaestraNormagetIdentNorma", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getListaInventarioDeNormas(){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ tokenid: userToken, action: "ListagetInventarioDeNormas", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getListaNormasModulo(id_modulo:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_modulo: id_modulo, tokenid: userToken, action: "ListagetNormas", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getListaControles(id_comportamiento:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_comportamiento: id_comportamiento, tokenid: userToken, action: "PenalGetListaControles", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getListaAmbitos(){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ tokenid: userToken, action: "ListagetAmbitos", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getListaBloques(lcuestionario: number = 0){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ tokenid: userToken, lcuestionario: lcuestionario, action: "ListagetBloques", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getListaAreasDelito(lcuestionario: number = 0){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ tokenid: userToken, lcuestionario: lcuestionario, action: "PenalGetListaAreasDelito", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getListaAreas(id_bloque: number, lcuestionario: number = 0){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_bloque: id_bloque, lcuestionario: lcuestionario, tokenid: userToken, action: "ListagetAreas", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getListaRiesgos(id_areadelito: number, lcuestionario: number = 0){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_areadelito: id_areadelito, lcuestionario: lcuestionario, tokenid: userToken, action: "PenalGetListaRiesgos", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getListaModulos(id_area: number, lcuestionario: number = 0){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_area: id_area, lcuestionario: lcuestionario, tokenid: userToken, action: "ListagetModulos", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getListaSupuestos(id_riesgo: number, lcuestionario: number = 0){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_riesgo: id_riesgo, lcuestionario: lcuestionario, tokenid: userToken, action: "PenalGetListaComportamientosDelictivos", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getNorma(id_norma){

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers});

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_norma: id_norma,  tokenid: userToken, action: "NormagetNorma", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getControl(id_control){

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers});

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_control: id_control,  tokenid: userToken, action: "PenalGetControl", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getNormaMaestra(id_norma){

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers});

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_norma: id_norma,  tokenid: userToken, action: "MaestraNormagetNorma", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getNormaHistorial(id_norma){
    
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers});

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_norma: id_norma,  tokenid: userToken, action: "MaestraNormaHistorial", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getBloque(id_bloque:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_bloque: id_bloque,  tokenid: userToken, action: "BloquegetBloque", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getAreaDelito(id_areadelito:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_areadelito: id_areadelito,  tokenid: userToken, action: "PenalgetAreaDelito", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getArea(id_area:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_area: id_area,  tokenid: userToken, action: "AreagetArea", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getRiesgo(id_riesgo:number){

    console.log(id_riesgo);

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_riesgo: id_riesgo,  tokenid: userToken, action: "PenalGetRiesgo", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getModulo(id_modulo:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_modulo: id_modulo,  tokenid: userToken, action: "ModulogetModulo", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getSupuesto(id_comportamiento:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_comportamiento: id_comportamiento,  tokenid: userToken, action: "PenalGetComportamiento", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  setNormaMaestraModulo(id_modulo:number, id_norma: number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_modulo: id_modulo, id_norma: id_norma,  tokenid: userToken, action: "MaestraNormaAsociaModulo", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  setNormaMaestraAsociaNorma(id_norma_padre:number, id_norma: number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_norma_padre: id_norma_padre, id_norma: id_norma,  tokenid: userToken, action: "MaestraNormaAsociaNorma", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  delNormaMaestraAsociaNorma(id_jerarquia:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_jerarquia: id_jerarquia, tokenid: userToken, action: "MaestraNormaDelAsociaNorma", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getNormaMaestraAsociaNorma(id_norma: number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_norma: id_norma,  tokenid: userToken, action: "MaestraNormaGetListaNormasEnlazadas", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getListaEtiquetasNorma(id_norma: number = 0){

    let userToken : string = localStorage.getItem('currentUserToken');

    let accion :string = "MaestraNormaListaEtiquetas";
    if (id_norma != 0){
      accion = "MaestraNormaListaEtiquetasNorma";
    }

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_norma: id_norma,  tokenid: userToken, action: accion, api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });

  }

  addEtiquetasNorma(id_norma: number = 0, etiqueta: string){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ etiqueta: etiqueta, id_norma: id_norma,  tokenid: userToken, action: "MaestraNormaAddEtiquetaNorma", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });

  }

  delEtiquetasNorma(id_norma: number = 0, id_etiqueta: number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_etiqueta: id_etiqueta, id_norma: id_norma,  tokenid: userToken, action: "MaestraNormaDelEtiquetaNorma", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });

  }

  setNorma(norma: any){

    let userToken : string = localStorage.getItem('currentUserToken');

    norma.tokenid = userToken;
    norma.action = "NormasetNorma";
    norma.api_keytoken = AppSettings.API_KEYTOKEN;

    console.log(norma);

    return this.http.post(AppSettings.API_URL, JSON.stringify(norma))
        .map((response2: Response) => {

            console.log(response2);

            if (!this.seguridad.getError(response2)){ //si no hay error

              return response2;

            }

        });
  }

  setControl(control: any){

    let userToken : string = localStorage.getItem('currentUserToken');

    control.tokenid = userToken;
    control.action = "PenalSetControl";
    control.api_keytoken = AppSettings.API_KEYTOKEN;

    console.log(control);

    return this.http.post(AppSettings.API_URL, JSON.stringify(control))
        .map((response2: Response) => {

            console.log(response2);

            if (!this.seguridad.getError(response2)){ //si no hay error

              return response2;

            }

        });
  }


  setNormaMaestra(norma: any){

    let userToken : string = localStorage.getItem('currentUserToken');

    norma.tokenid = userToken;
    norma.action = "MaestraNormasetNorma";
    norma.api_keytoken = AppSettings.API_KEYTOKEN;

    console.log(norma);

    return this.http.post(AppSettings.API_URL, JSON.stringify(norma))
        .map((response2: Response) => {

            console.log(response2);

            if (!this.seguridad.getError(response2)){ //si no hay error

              return response2;

            }

        });
  }

  setModulo(modulo: any){

    let userToken : string = localStorage.getItem('currentUserToken');

    modulo.tokenid = userToken;
    modulo.action = "ModulosetModulo";
    modulo.api_keytoken = AppSettings.API_KEYTOKEN;

    console.log(modulo);

    return this.http.post(AppSettings.API_URL, JSON.stringify(modulo))
        .map((response: Response) => {

            console.log(response);

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  setSupuesto(supuesto: any){

    let userToken : string = localStorage.getItem('currentUserToken');

    supuesto.tokenid = userToken;
    supuesto.action = "PenalSetComportamiento";
    supuesto.api_keytoken = AppSettings.API_KEYTOKEN;

    console.log(supuesto);

    return this.http.post(AppSettings.API_URL, JSON.stringify(supuesto))
        .map((response: Response) => {

            console.log(response);

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  setModulosAfectados(modulosafectados: any){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ modulosafectados: modulosafectados, tokenid: userToken, action: "MaestraNormaUpdateChilds", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  setArea(area: any){

    let userToken : string = localStorage.getItem('currentUserToken');

    area.tokenid = userToken;
    area.action = "AreasetArea";
    area.api_keytoken = AppSettings.API_KEYTOKEN;

    //console.log(area);

    return this.http.post(AppSettings.API_URL, JSON.stringify(area))
        .map((response: Response) => {

            console.log(response);

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  setRiesgo(riesgo: any){

    let userToken : string = localStorage.getItem('currentUserToken');

    riesgo.tokenid = userToken;
    riesgo.action = "PenalSetRiesgo";
    riesgo.api_keytoken = AppSettings.API_KEYTOKEN;

    //console.log(area);

    return this.http.post(AppSettings.API_URL, JSON.stringify(riesgo))
        .map((response: Response) => {

            console.log(response);

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  setBloque(bloque: any){

    let userToken : string = localStorage.getItem('currentUserToken');

    bloque.tokenid = userToken;
    bloque.action = "BloquesetBloque";
    bloque.api_keytoken = AppSettings.API_KEYTOKEN;

    console.log(bloque);

    return this.http.post(AppSettings.API_URL, JSON.stringify(bloque))
        .map((response: Response) => {

            console.log(response);

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  setAreaDelito(areadelito: any){

    let userToken : string = localStorage.getItem('currentUserToken');

    areadelito.tokenid = userToken;
    areadelito.action = "PenalsetAreaDelito";
    areadelito.api_keytoken = AppSettings.API_KEYTOKEN;

    return this.http.post(AppSettings.API_URL, JSON.stringify(areadelito))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  deleteBloque(id_bloque:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_bloque: id_bloque,  tokenid: userToken, action: "BloqueDeleteBloque", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  deleteAreaDelito(id_areadelito:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_areadelito: id_areadelito,  tokenid: userToken, action: "PenalDeleteAreaDelito", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  deleteArea(id_area:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_area: id_area,  tokenid: userToken, action: "AreaDeleteArea", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  deleteRiesgo(id_riesgo:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_riesgo: id_riesgo,  tokenid: userToken, action: "PenalDeleteRiesgo", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  deleteModulo(id_modulo:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_modulo: id_modulo,  tokenid: userToken, action: "ModuloDeleteModulo", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  deleteSupuesto(id_comportamiento:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_comportamiento: id_comportamiento,  tokenid: userToken, action: "PenalDeleteComportamiento", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  deleteNorma(id_norma:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_norma: id_norma,  tokenid: userToken, action: "NormaDeleteNorma", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  deleteControl(id_control:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_control: id_control,  tokenid: userToken, action: "PenalDeleteControl", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  deleteNormaMaestra(id_norma:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_norma: id_norma,  tokenid: userToken, action: "MaestraNormaDeleteNorma", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

}



// WEBPACK FOOTER //
// ./src/app/_services/normas.service.ts